import { render, staticRenderFns } from "./FinishedProjectsPage.vue?vue&type=template&id=61d6eb78&scoped=true"
import script from "./FinishedProjectsPage.vue?vue&type=script&lang=ts"
export * from "./FinishedProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./FinishedProjectsPage.vue?vue&type=style&index=0&id=61d6eb78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d6eb78",
  null
  
)

export default component.exports